import React from 'react';
import './Home.css';
import NewsList from '../components/NewsList';

const Home = () => {
    return (
        <div className="home-container">
            <NewsList />
        </div>
    );
};

export default Home;
